var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "coupon-dia" },
    [
      _vm.validCouponListSort
        ? _c(
            "van-popup",
            {
              attrs: { position: "bottom" },
              on: { close: _vm.close },
              model: {
                value: _vm.showCouponPopup,
                callback: function ($$v) {
                  _vm.showCouponPopup = $$v
                },
                expression: "showCouponPopup",
              },
            },
            [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("lang.giftSign.coupon"))),
              ]),
              _c(
                "van-tabs",
                {
                  attrs: { swipeable: "" },
                  model: {
                    value: _vm.active,
                    callback: function ($$v) {
                      _vm.active = $$v
                    },
                    expression: "active",
                  },
                },
                _vm._l(_vm.tebTit, function (tabOption) {
                  return _c(
                    "van-tab",
                    {
                      key: tabOption.id,
                      attrs: {
                        title:
                          tabOption.id == 0
                            ? `${tabOption.tit0}(${_vm.validCouponListSort.length})`
                            : `${tabOption.tit1}(${_vm.expiredCouponList.length})`,
                      },
                    },
                    [
                      tabOption.id == 0
                        ? _c(
                            "div",
                            { staticClass: "tab tab1" },
                            [
                              _vm._l(
                                _vm.validCouponListSort,
                                function (item, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass: "coupon",
                                      on: {
                                        click: function ($event) {
                                          return _vm.chooseCoupon(item, index)
                                        },
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "left" }, [
                                        _c("div", {
                                          staticClass: "coupon-head",
                                        }),
                                        _c("div", { staticClass: "dis-text" }, [
                                          _c("p", { staticClass: "text" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("lang.coupon.extra")
                                              ) +
                                                " " +
                                                _vm._s(item.amount)
                                            ),
                                          ]),
                                          _c("p", { staticClass: "text-tip" }, [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("lang.coupon.desc1")
                                                ) +
                                                _vm._s(item.minUseAmount) +
                                                " "
                                            ),
                                            _c("img", {
                                              attrs: {
                                                src: _vm.getMatchImg("coin"),
                                              },
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("lang.coupon.desc2")
                                                ) +
                                                " "
                                            ),
                                          ]),
                                          _c(
                                            "span",
                                            { staticClass: "text-time" },
                                            [
                                              _vm._v(
                                                "Expires: " +
                                                  _vm._s(
                                                    _vm.handleMoment(
                                                      item.expiredTime,
                                                      "YYYY/MM/DD"
                                                    )
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]),
                                      _c("div", { staticClass: "right" }, [
                                        _c(
                                          "div",
                                          { staticClass: "coupon-num" },
                                          [
                                            _vm.chooseCouponId &&
                                            _vm.chooseCouponId ==
                                              item.couponRecordId
                                              ? _c("div", {
                                                  staticClass: "radio-checked",
                                                })
                                              : _c("div", {
                                                  staticClass: "radio",
                                                }),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  )
                                }
                              ),
                              _vm.validCouponListSort.length == 0
                                ? _c("div", { staticClass: "no-coupons" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("lang.intimate.noCouponTip")
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            2
                          )
                        : _vm._e(),
                      tabOption.id == 1
                        ? _c(
                            "div",
                            { staticClass: "tab tab2" },
                            [
                              _vm._l(
                                _vm.expiredCouponList,
                                function (item, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass: "coupon expired-coupon",
                                    },
                                    [
                                      _c("div", { staticClass: "left" }, [
                                        _c("div", {
                                          staticClass: "coupon-head",
                                        }),
                                        _c("div", { staticClass: "dis-text" }, [
                                          _c("p", { staticClass: "text" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("lang.coupon.extra")
                                              ) +
                                                " " +
                                                _vm._s(item.amount)
                                            ),
                                          ]),
                                          _c("p", { staticClass: "text-tip" }, [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("lang.coupon.desc1")
                                                ) +
                                                _vm._s(item.minUseAmount)
                                            ),
                                            _c("img", {
                                              attrs: {
                                                src: _vm.getMatchImg("coin"),
                                              },
                                            }),
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("lang.coupon.desc2")
                                              ) + " "
                                            ),
                                          ]),
                                          _c(
                                            "span",
                                            { staticClass: "text-time" },
                                            [
                                              _vm._v(
                                                "Expires: " +
                                                  _vm._s(
                                                    _vm.handleMoment(
                                                      item.expiredTime,
                                                      "YYYY/MM/DD"
                                                    )
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]),
                                      _c("div", { staticClass: "right" }, [
                                        _c(
                                          "div",
                                          { staticClass: "coupon-num" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "expired" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "lang.intimate.expired"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  )
                                }
                              ),
                              _vm.expiredCouponList.length == 0
                                ? _c("div", { staticClass: "no-coupons" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("lang.intimate.noCouponTip")
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            2
                          )
                        : _vm._e(),
                    ]
                  )
                }),
                1
              ),
              _c(
                "div",
                {
                  staticClass: "confirm-btn",
                  class: {
                    "no-click":
                      (_vm.active == 0 &&
                        (_vm.validCouponListSort.length == 0 ||
                          this.chooseCouponId == null)) ||
                      _vm.active == 1,
                  },
                  on: { click: _vm.handleConfirm },
                },
                [_vm._v(" " + _vm._s(_vm.$t("lang.confirm")) + " ")]
              ),
              _c("div", {
                style: { width: "100%", height: `${_vm.bottomBarHeight}px` },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }